export const features = [
  {
    img: "focus.svg",
    title: "سناریو‌های آماده",
    title_en: "",
    desc: "بیش از ۲۰۰۰ سناریوی شناسایی تهدید مبتنی بر چارچوب MITRE ATT&CK در سامانه SIEM آبالون برای پوشش دقیق حملات شناخته‌شده",
  },
  {
    img: "devops.svg",
    title: "مدیریت و تحلیل متمرکز امنیت",
    title_en: "",
    desc: "جمع‌آوری متمرکز و تحلیل بلادرنگ داده‌های امنیتی از تمام بخش‌های زیرساخت در داشبوردهای گرافیکی همراه با گزارش‌های مدیریتی دقیق",
  },
  {
    img: "technical.svg",
    title: "تحلیل رفتار کاربران و سیستم‌ها (UBA/UEBA)",
    title_en: "",
    desc: "شناسایی فعالیت‌های غیرعادی و ارسال هشدارهای فوری با پایش مداوم و مدل‌سازی رفتاری به کمک الگوریتم‌های پیشرفته یادگیری ماشین",
  },
  {
    img: "monitoring.svg",
    title: "اولویت‌بندی ریسک‌ها",
    title_en: "",
    desc: "درجه‌بندی و اولویت‌بندی خودکار رویدادها توسط سامانه SIEM آبالون، بر اساس اهمیت سرویس یا شدت حملات، برای تمرکز روی موثرترین تهدیدات",
  },
  {
    img: "exclusive.svg",
    title: "یکپارچه‌سازی فرایندها",
    title_en: "",
    desc: "یکپارچه‌سازی و اتصال به سامانه‌های SOAR برای اجرای خودکار دستورالعمل‌ها در جهت کاهش میانگین زمان تشخیص، پاسخ و حذف فعالیت‌های تکراری",
  },
  {
    img: "hardening.svg",
    title: "تحلیلگر حملات پیچیده (Attack Analyzer)",
    title_en: "",
    desc: "دارای ۵۰۰ سناریو برای شناسایی خودکار حملات پیشرفته چندمرحله‌ای و کشف تخلفات تراکنش‌های مالی با استفاده از هوش مصنوعی",
  },
];

export const usages = [
  {
    title: "شناسایی تهدیدات پیشرفته",
    specialChar: "",
    desc: "شناسایی حملات پیچیده و چندمرحله‌ای نیازمند دقت بالا و ابزارهای تخصصی است. با رصد مستمر مسیر حملات و تحلیل رفتاری دقیق، سامانه SIEM آبالون امکان شناسایی زودهنگام آن‌ها را فراهم می‌سازد.",
  },
  {
    title: "شکار تهدیدها (Threat Hunting)",
    specialChar: "",
    desc: "با تبدیل داده‌های پراکنده به دانش‌های عملیاتی، شناسایی پیش‌دستانه و تقریباً آنی حملات ممکن می‌شود و به تحلیل‌گران کمک می‌کند تهدیدات پنهان شبکه را پیش از ایجاد خسارت کشف کنند.",
  },
  {
    title: "مقابله با باج‌افزارها (Ransomware)",
    specialChar: "",
    desc: "در برابر حملات سریع باج‌افزاری، واکنش آنی اهمیت دارد. SIEM آبالون با شناسایی پیشگیرانه، قرنطینه و پاسخ خودکار، از گسترش خسارت جلوگیری می‌کند.",
  },
  {
    title: "پشتیبانی از انطباق و ممیزی (Compliance)",
    specialChar: "",
    desc: "با تولید گزارش‌های دقیق و مستند، امکان اثبات انطباق با سیاست‌های امنیتی و الزامات قانونی فراهم می‌شود و فرآیندهای ممیزی سریع‌تر انجام می‌گیرد.",
  },
];

export const os = [
  {
    name: "ابزارهای امنیتی و مدیریت دسترسی ",
    apps: [
      {
        app: "Palo Alto Networks",
        img: "palo-alto-networks.svg",
        alt: "Palo Alto Networks",
        title: "Palo Alto Networks",
      },
      {
        app: "Fortinet",
        img: "Fortinet.svg",
        alt: "Fortinet",
        title: "Fortinet",
      },
      {
        app: "Cisco ASA",
        img: "Cisco-ASA.svg",
        alt: "Cisco ASA",
        title: "Cisco ASA",
      },
      {
        app: "F5 Networks",
        img: "F5-Network.svg",
        alt: "F5 Networks",
        title: "F5 Networks",
      },
      {
        app: "CyberArk",
        img: "CyberArk.svg",
        alt: "CyberArk",
        title: "CyberArk",
      },
      {
        app: "Barracuda",
        img: "Barracuda.svg",
        alt: "Barracuda",
        title: "Barracuda",
      },
    ],
  },
  {
    name: "ابزارهای EDR و XDR",
    apps: [
      {
        app: "Kaspersky Endpoint Security",
        img: "Kaspersky-Endpoint-Security.svg",
        alt: "Kaspersky Endpoint Security",
        title: "Kaspersky Endpoint Security",
      },
      {
        app: "Bitdefender GravityZone",
        img: "Bitdefender-GravityZone.svg",
        alt: "Bitdefender GravityZone",
        title: "Bitdefender GravityZone",
      },
      {
        app: "Sophos Intercept X",
        img: "Sophos-Intercept- X.svg",
        alt: "Sophos Intercept X",
        title: "Sophos Intercept X",
      },
      {
        app: "Trend Micro Apex One",
        img: "Trend-Micro-Apex-One.svg",
        alt: "Trend Micro Apex One",
        title: "Trend Micro Apex One",
      },
      {
        app: "McAfee MVISION EDR",
        img: "McAfee-MVISION-EDR.svg",
        alt: "McAfee MVISION EDR",
        title: "McAfee MVISION EDR",
      },
      {
        app: "CrowdStrike Falcon",
        img: "CrowdStrike-Falcon.svg",
        alt: "CrowdStrike Falcon",
        title: "CrowdStrike Falcon",
      },
    ],
  },
  {
    name: "فایروال‌ها و IDS/IPS",
    apps: [
      {
        app: "Cisco Firepower",
        img: "Cisco-ASA.svg",
        alt: "Cisco Firepower",
        title: "Cisco Firepower",
      },
      {
        app: "Juniper SRX",
        img: "Juniper-SRX.svg",
        alt: "Juniper SRX",
        title: "Juniper SRX",
      },
      {
        app: "FortiGate",
        img: "Fortinet.svg",
        alt: "FortiGate",
        title: "FortiGate",
      },
      {
        app: "Palo Alto NGFW",
        img: "Palo-Alto-NGFW.svg",
        alt: "Palo Alto NGFW",
        title: "Palo Alto NGFW",
      },
      {
        app: "SonicWall TZ",
        img: "SonicWall-TZ.svg",
        alt: "SonicWall TZ",
        title: "SonicWall TZ",
      },
      {
        app: "Barracuda NextGen",
        img: "Barracuda-NextGen.svg",
        alt: "Barracuda NextGen",
        title: "Barracuda NextGen",
      },
    ],
  },
  {
    name: "ابزارهای شبکه و مدیریت ترافیک",
    apps: [
      {
        app: "Arista Networks",
        img: "Arista-Networks.svg",
        alt: "Arista Networks",
        title: "Arista Networks",
      },
      {
        app: "MikroTik RouterOS",
        img: "MikroTik-RouterOS.svg",
        alt: "MikroTik RouterOS",
        title: "MikroTik RouterOS",
      },
      {
        app: "Ubiquiti UniFi",
        img: "Ubiquiti-UniFi.svg",
        alt: "Ubiquiti UniFi",
        title: "Ubiquiti UniFi",
      },
      {
        app: "Paessler NetFlow",
        img: "Paessler-NetFlow.svg",
        alt: "Paessler NetFlow",
        title: "Paessler NetFlow",
      },
      {
        app: "Wireshark",
        img: "Wireshark.svg",
        alt: "Wireshark",
        title: "Wireshark",
      },
      {
        app: "Manageengine IPFIX",
        img: "Manageengine-IPFIX.svg",
        alt: "Manageengine IPFIX",
        title: "Manageengine IPFIX",
      },
    ],
  },
  {
    name: "ابزارهای مدیریت آسیب‌پذیری و تست نفوذ",
    apps: [
      {
        app: "Qualys",
        img: "Qualys.svg",
        alt: "Qualys",
        title: "Qualys",
      },
      {
        app: "Tenable Nessus",
        img: "Tenable-Nessus.svg",
        alt: "Tenable Nessus",
        title: "Tenable Nessus",
      },
      {
        app: "Nmap",
        img: "Nmap.svg",
        alt: "Nmap",
        title: "Nmap",
      },
      {
        app: "Rapid7 Nexpose",
        img: "Rapid7-Nexpose.svg",
        alt: "Rapid7 Nexpose",
        title: "Rapid7 Nexpose",
      },
      {
        app: "Metasploit",
        img: "Metasploit.svg",
        alt: "Metasploit",
        title: "Metasploit",
      },
      {
        app: "Acunetix",
        img: "Acunetix.svg",
        alt: "Acunetix",
        title: "Acunetix",
      },
    ],
  },
];

export const stats = [
  {
    title: "۴۶۰۰ ساعت",
    subtitle: "صرفه‌جویی سالانه",
    cap: "با کاهش هشدارهای کاذب و حذف فرایند‌های تکراری",
  },
  {
    title: "۹۰٪",
    subtitle: "کاهش زمان بررسی",
    cap: "با اولویت‌بندی هوشمند و خودکار تهدیدات",
  },
  {
    title: "۶۰٪",
    subtitle: "کاهش ریسک بحران",
    cap: "ظرفیت مقابله با حملات سایب با پایش مداوم و شناسایی سریع تهدیدات",
  },
  {
    title: "۷۰۰+",
    subtitle: "اتصال از پیش آماده",
    cap: "به ابزارهای امنیتی جهانی برای دریافت لاگ",
  },
];

export const popularServices = [
  {
    title: "امنیت ابری",
    desc: "با استفاده از راهکارهای امنیتی پیشرفته مانند SOC، فایروال ابری، WAF و سامانه (SIEM) از سرویس‌های سازمانی خود در فضای ابری محافظت کنید.",
    logo: "VPS-Service.svg",
    route: "/cloud-security",
    imgAlt: "سرویس امنیت ابری آبالون",
    imgTitle: "سرویس امنیت ابری آبالون",
  },
  {
    title: "سرور اختصاصی",
    desc: "با خرید سرور اختصاصی آبالون، به منابع سخت‌افزاری قدرتمند در دیتاسنترهای پیشرفته سراسر کشور به‌صورت Bare Metal یا با معماری ابری دسترسی داشته باشید.",
    logo: "CloudGuard-Service.svg",
    route: "/dedicated-server",
    imgAlt: "سرویس سرور اختصاصی آبالون",
    imgTitle: "سرویس سرور اختصاصی آبالون",
  },
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری تمامی قابلیت‌های یک دیتاسنتر فیزیکی را روی ابر برایتان فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌ترین نیازهای ابری شما باشد. ",
    logo: "VPC-Service.svg",
    route: "/vpc",
    imgAlt: "دیتاسنتر ابری آبالون",
    imgTitle: "دیتاسنتر ابری آبالون",
  },
  {
    title: "شبکه توزیع محتوای CDN آبالون",
    desc: "با بیش از ۴۰ پاپ‌سایت فعال در ایران و ۵ قاره جهان، محتوای وب‌سایت و سرویس‌های آنلاین سازمان خود را با کمترین تأخیر، سریع‌تر و ایمن‌تر به کاربران برسانید.",
    logo: "ManagedService-Service.svg",
    route: "/cdn",
    imgAlt: "شبکه توزیع محتوای CDN آبالون",
    imgTitle: "شبکه توزیع محتوای CDN آبالون",
  },
];

export const questions = [
  {
    title: "سامانه SIEM آبالون چگونه به ارتقای امنیت سازمان کمک می‌کند؟",
    answer:
      "با گردآوری و تحلیل آنی داده‌های امنیتی از تمام بخش‌های زیرساخت، شناسایی تهدیدات پیش از وقوع و ارائه گزارش‌های دقیق به تیم SOC، سامانه SIEM آبالون نقش کلیدی در پیشگیری، کشف و پاسخ سریع به حوادث امنیتی ایفا می‌کند.",
  },
  {
    title: "استفاده از هوش مصنوعی و یادگیری ماشینی در SIEM چه مزیتی دارد؟",
    answer:
      "زیرساخت تحلیلی SIEM آبالون با بهره‌گیری از هوش مصنوعی، تصمیم‌گیری‌های دقیق‌تر و سریع‌تر را برای تیم امنیتی ممکن می‌سازد. الگوریتم‌های یادگیری ماشینی نیز با تحلیل مداوم داده‌های جدید، می‌توانند الگوهای رفتاری و تهدیدات نوظهور را شناسایی کرده و خود را با آن‌ها تطبیق دهند. این ترکیب باعث کاهش بار عملیاتی، افزایش دقت تحلیل‌ها و واکنش مؤثرتر در برابر تهدیدات می‌شود.",
  },
  {
    title:
      "SIEM آبالون چگونه در شناسایی و مدیریت تهدیدات مستمر پیشرفته (APT) و حملات چندمرحله‌ای عمل می‌کند؟",
    answer:
      "با ترکیب تحلیل رفتاری، تجمیع رویدادها و الگوریتم‌های هوش مصنوعی، سامانه SIEM آبالون می‌تواند زنجیره فعالیت‌های مشکوک را شناسایی و مسیر حمله را بازسازی کند تا پیش از بروز خسارت، واکنش مناسب انجام شود.",
  },
  {
    title:
      "آیا امکان اتصال سامانه SIEM آبالون به سایر سامانه‌های امنیتی وجود دارد؟",
    answer:
      "بله. SIEM ایرانی آبالون از استانداردهای یکپارچه‌سازی پشتیبانی می‌کند و می‌تواند با راهکارهایی مانند SOC ،SOAR و سیستم‌های تشخیص نفوذ (IDS/IPS) تبادل داده داشته باشد تا زنجیره دفاعی سازمان کامل‌تر شود.",
  },
  {
    title:
      "آیا سامانه SIEM آبالون قابلیت کار در زیرساخت‌های پراکنده و چند دیتاسنتر را دارد؟",
    answer:
      "بله، SIEM آبالون با پشتیبانی از تحلیل توزیع‌شده، می‌تواند داده‌ها و لاگ‌ها را از منابع مختلف در نقاط جغرافیایی متفاوت، جمع‌آوری و به‌صورت متمرکز تحلیل کند؛ بدون نیاز به تجمیع فیزیکی داده‌ها در یک محل خاص.",
  },
  {
    title:
      "آیا امکان استفاده از خدمات تحلیل و مانیتورینگ توسط تیم متخصص آبالون وجود دارد؟",
    answer:
      "بله، سازمان‌ها می‌توانند تحلیل‌های امنیتی را به تیم متخصص SOC آبالون بسپارند یا از امکانات سامانه SIEM آبالون به‌صورت مستقل بهره‌مند شوند. این انعطاف‌پذیری باعث می‌شود متناسب با نیاز و منابع سازمان، بهترین راهکار را انتخاب کنید.",
  },
];
